import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Clock } from 'lucide-react';
import { contactInfo, services } from '../mockData';

const Footer = () => {
  return (
    <footer className="footer-dark py-12">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_emre-tesisat/artifacts/70o6g2rv_WhatsApp%20G%C3%B6rsel%202025-11-07%20saat%2009.52.07_0d5a0921.jpg" 
                alt="EMRE TİCARET Logo"
                className="h-16 w-auto object-contain mb-4"
              />
            </div>
            <p className="text-gray-400 text-sm mb-4">
              İzmir'de su kaçağı tespiti, tesisat ve tadilat hizmetlerinde güvenilir çözüm ortağınız.
            </p>
            <div className="text-sm text-gray-500 mb-4">
              <p className="font-semibold text-yellow-500 mb-2">Bize sormadan evinizi kırdırmayın!</p>
            </div>
            
            {/* Instagram CTA */}
            <a 
              href={contactInfo.instagram} 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 rounded-lg text-white font-semibold text-sm transition-all"
            >
              <Instagram className="w-5 h-5" />
              <span>Instagram'da Takip Edin</span>
            </a>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-500">Hızlı Linkler</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-yellow-500 text-sm">Ana Sayfa</Link></li>
              <li><Link to="/hakkimizda" className="text-gray-400 hover:text-yellow-500 text-sm">Hakkımızda</Link></li>
              <li><Link to="/hizmetler" className="text-gray-400 hover:text-yellow-500 text-sm">Hizmetler</Link></li>
              <li><Link to="/ornek-isler" className="text-gray-400 hover:text-yellow-500 text-sm">Örnek İşler</Link></li>
              <li><Link to="/blog" className="text-gray-400 hover:text-yellow-500 text-sm">Blog</Link></li>
              <li><Link to="/yorumlar" className="text-gray-400 hover:text-yellow-500 text-sm">Müşteri Yorumları</Link></li>
              <li><Link to="/iletisim" className="text-gray-400 hover:text-yellow-500 text-sm">İletişim</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-500">Hizmetlerimiz</h4>
            <ul className="space-y-2">
              {services.slice(0, 5).map((service) => (
                <li key={service.id}>
                  <Link to={`/hizmet/${service.id}`} className="text-gray-400 hover:text-yellow-500 text-sm">
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-500">İletişim</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-sm text-gray-400">
                <MapPin className="w-4 h-4 text-yellow-500 mt-0.5 flex-shrink-0" />
                <span>{contactInfo.address}</span>
              </li>
              {contactInfo.phones.map((phone, index) => (
                <li key={index} className="flex items-center space-x-2 text-sm">
                  <Phone className="w-4 h-4 text-yellow-500" />
                  <a href={`tel:${phone.number.replace(/\s/g, '')}`} className="text-gray-400 hover:text-yellow-500">
                    {phone.number}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 mt-8">
          <p className="text-sm text-gray-500 text-center">
            © {new Date().getFullYear()} EMRE TİCARET. Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
